export const DataConf = {
  initialState: {
    loading: false,
    error: null,
    data: [],
    meta: null,
  },
};

export const AreaOptions = [
  {
    id: 'NORD',
    label: 'NORD',
  },
  {
    id: 'SUD',
    label: 'SUD',
  },
  {
    id: 'CARIBBEAN',
    label: 'CARIBBEAN',
  },
];
